import {
  Logout,
  PersonOutline,
  SettingsOutlined,
  Today
} from "@mui/icons-material"
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack
} from "@mui/material"
import Auth from "auth/Auth"
import useUserContext from "hooks/useUserContext"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router-dom"
import { ROUTES } from "utils/constants"

import { StyledToolbar } from "../Header/Header.styles"
import { ScreenListType } from "../Header/Header.types"
import NavigationLinks from "../NavigationLinks"
import {
  NavigationContainer,
  StyledEverDrivenLogo,
  StyledList
} from "./MainDrawer.styles"

const MainDrawer = () => {
  const { t } = useTranslation("global")
  const { pathname } = useLocation()

  const { userIsAdmin } = useUserContext()

  const screens = [
    {
      displayName: t("component.Header.schedule"),
      route: ROUTES.SCHEDULE,
      testId: "NavigationSchedule",
      icon: <Today />
    },
    {
      displayName: t("component.Header.drivers"),
      route: ROUTES.DRIVERS,
      testID: "NavigationDrivers",
      icon: <PersonOutline />
    }
  ] as ScreenListType[]

  if (userIsAdmin) {
    screens.push({
      displayName: t("component.Header.users"),
      route: ROUTES.USERS,
      testID: "NavigationUsers",
      icon: <SettingsOutlined />
    })
  }

  const handleLogoutClick = useCallback(() => {
    Auth.signOut()
    localStorage.clear()
  }, [])

  return (
    <>
      <StyledToolbar />
      <Stack flex="1" justifyContent="space-between">
        <Stack>
          <StyledList component="nav">
            {screens.map(
              ({ displayName, route, testID, icon }, screenIndex) => {
                const navLinkKey = `link-key-${screenIndex}-${displayName}`
                const isActive = pathname.includes(route)

                return (
                  <ListItemButton
                    component={Link}
                    data-testid={testID}
                    key={navLinkKey}
                    selected={isActive}
                    to={route}
                  >
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText primary={displayName} />
                  </ListItemButton>
                )
              }
            )}
          </StyledList>

          <NavigationContainer>
            <Divider />
            <NavigationLinks />
          </NavigationContainer>
        </Stack>

        <List>
          <ListItemButton data-testid="SignOutLink" onClick={handleLogoutClick}>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText primary={t("component.Header.signOut")} />
          </ListItemButton>
          <ListItem>
            <StyledEverDrivenLogo />
          </ListItem>
        </List>
      </Stack>
    </>
  )
}

export default MainDrawer
